import type { ISportAngle, TResponseAngles, TResponseSportAngle } from "../types/event-angles";
import { formatSportAngle } from "~/videos/helpers/format-angles";
import type { TSportType } from "~/types";

export async function getAngles(): Promise<Record<string, ISportAngle[]>> {
  return useAPI<{ data: TResponseAngles[] }>(`/api/v1/events/angles`).then(res => Object.fromEntries(Object.entries(res.data || {}).map(([key, list]) => [key, list.map(formatSportAngle)])) ?? {});
}

export const getCachedAngles = useMemoize(getAngles);

export async function getAnglesBySportType(type: TSportType): Promise<ISportAngle[] | null> {
  return useAPI<{ data: TResponseSportAngle[] }>(`/api/v1/events/angles`, {
    query: {
      sportType: type,
    },
  }).then(res => res.data.map(formatSportAngle) ?? []);
}

export const getCachedAnglesBySportType = useMemoize(getAnglesBySportType);
